module.exports = __webpack_public_path__ + "static/media/DeleteKeyFrameDisable.61f4158e.svg";